export enum AttachmentKeys {
	Attachment = "attachment",
	Attachments = "attachments",
	DeliveryReceiptInfo = "delivery_receipt_info",
	DeliveryReceiptImage = "delivery_receipt_image",
}
